import React, { useState, useEffect } from "react";
import api from "../services/api";

export default function DirectoryPage() {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name_fr: "", name_en: "", head: "", phone: "", email: "", hours: "Lun-Ven: 7h30-15h30", icon: "🏛️", color: "#1A5C2A" });

  useEffect(() => { loadDepartments(); }, []);

  const loadDepartments = () => {
    setLoading(true);
    api.get("/directory/").then(r => { setDepartments(Array.isArray(r.data) ? r.data : []); setLoading(false); }).catch(() => setLoading(false));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) { await api.put(`/directory/${editing.id}/`, form); }
      else { await api.post("/directory/", form); }
      setShowForm(false); setEditing(null);
      setForm({ name_fr: "", name_en: "", head: "", phone: "", email: "", hours: "Lun-Ven: 7h30-15h30", icon: "🏛️", color: "#1A5C2A" });
      loadDepartments();
    } catch (err) {
      const detail = err.response
        ? `Erreur ${err.response.status}: ${JSON.stringify(err.response.data)}`
        : `Erreur reseau: ${err.message}`;
      alert(detail);
    }
  };

  const handleEdit = (dept) => {
    setEditing(dept);
    setForm({ name_fr: dept.name_fr || "", name_en: dept.name_en || "", head: dept.head || "", phone: dept.phone || "", email: dept.email || "", hours: dept.hours || "", icon: dept.icon || "🏛️", color: dept.color || "#1A5C2A" });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ce département?")) return;
    await api.delete(`/directory/${id}/`);
    loadDepartments();
  };

  const s = { width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box" };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <h1 style={{ color: "#1A1A2E", fontSize: 24, fontWeight: 800, margin: 0 }}>Annuaire Municipal</h1>
          <p style={{ color: "#8A8A9A", fontSize: 14, margin: "4px 0 0" }}>{departments.length} département(s)</p>
        </div>
        <button onClick={() => { setShowForm(true); setEditing(null); }}
          style={{ background: "linear-gradient(135deg, #0F3D1A, #1A5C2A)", color: "white", border: "none", padding: "12px 24px", borderRadius: 12, cursor: "pointer", fontSize: 14, fontWeight: 700, fontFamily: "Poppins" }}>
          + Ajouter
        </button>
      </div>

      {showForm && (
        <div style={{ background: "white", borderRadius: 20, padding: 28, marginBottom: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.1)", border: "2px solid #1A5C2A" }}>
          <h3 style={{ margin: "0 0 20px" }}>{editing ? "Modifier" : "Nouveau"} département</h3>
          <form onSubmit={handleSubmit}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Nom (FR) *</label><input value={form.name_fr} onChange={e => setForm({...form, name_fr: e.target.value})} required style={s} /></div>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Nom (EN)</label><input value={form.name_en} onChange={e => setForm({...form, name_en: e.target.value})} style={s} /></div>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Chef de service</label><input value={form.head} onChange={e => setForm({...form, head: e.target.value})} style={s} /></div>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Téléphone</label><input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} style={s} /></div>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Email</label><input value={form.email} onChange={e => setForm({...form, email: e.target.value})} style={s} /></div>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Horaires</label><input value={form.hours} onChange={e => setForm({...form, hours: e.target.value})} style={s} /></div>
            </div>
            <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Icône</label><input value={form.icon} onChange={e => setForm({...form, icon: e.target.value})} style={{...s, width: 80}} /></div>
              <div><label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 4 }}>Couleur</label><input type="color" value={form.color} onChange={e => setForm({...form, color: e.target.value})} style={{ width: 60, height: 40 }} /></div>
            </div>
            <div style={{ display: "flex", gap: 12 }}>
              <button type="submit" style={{ background: "#1A5C2A", color: "white", border: "none", padding: "10px 24px", borderRadius: 10, cursor: "pointer", fontFamily: "Poppins", fontWeight: 600 }}>{editing ? "Mettre à jour" : "Créer"}</button>
              <button type="button" onClick={() => setShowForm(false)} style={{ background: "#F5F6FA", color: "#8A8A9A", border: "none", padding: "10px 24px", borderRadius: 10, cursor: "pointer", fontFamily: "Poppins" }}>Annuler</button>
            </div>
          </form>
        </div>
      )}

      {loading ? <p style={{ textAlign: "center", color: "#8A8A9A" }}>Chargement...</p> : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 16 }}>
          {departments.map(dept => (
            <div key={dept.id} style={{ background: "white", borderRadius: 16, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", borderTop: `4px solid ${dept.color || "#1A5C2A"}` }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                <span style={{ fontSize: 28 }}>{dept.icon || "🏛️"}</span>
                <div style={{ display: "flex", gap: 6 }}>
                  <button onClick={() => handleEdit(dept)} style={{ background: "#1A5C2A20", color: "#1A5C2A", border: "none", padding: "4px 10px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 600, fontFamily: "Poppins" }}>Modifier</button>
                  <button onClick={() => handleDelete(dept.id)} style={{ background: "#D32F2F20", color: "#D32F2F", border: "none", padding: "4px 10px", borderRadius: 6, cursor: "pointer", fontSize: 11, fontWeight: 600, fontFamily: "Poppins" }}>Suppr.</button>
                </div>
              </div>
              <h3 style={{ margin: "0 0 4px", fontSize: 14, fontWeight: 700, color: "#1A1A2E" }}>{dept.name_fr}</h3>
              <p style={{ margin: "0 0 4px", fontSize: 12, color: "#8A8A9A" }}>{dept.head}</p>
              {dept.phone && <p style={{ margin: "0 0 2px", fontSize: 12, color: "#8A8A9A" }}>📞 {dept.phone}</p>}
              {dept.email && <p style={{ margin: "0 0 2px", fontSize: 12, color: "#8A8A9A" }}>✉️ {dept.email}</p>}
              {dept.hours && <p style={{ margin: 0, fontSize: 12, color: "#8A8A9A" }}>🕐 {dept.hours}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
